import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceService } from '../../services/api-service.service';
import { environment } from '../../../environments/environment.development';
import { LoaderService } from '../../services/loader.service';
import { MyModalComponent } from '../my-modal/my-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { WalletServiceService } from 'src/app/services/walletService';

@Component({
  selector: 'app-direct-purchase',
  templateUrl: './direct-purchase.component.html',
  styleUrls: ['./direct-purchase.component.scss'],
})
export class DirectPurchaseComponent implements OnInit {
  productId: string = '';
  size: string = 'small';
  quantity: number = 1;
  subTotal: number = 0;
  shippingCharge: number = 0;
  discountPrice: number = 0;
  balance: number = 0;
  total: number = 0;
  couponCode: string = '';
  isCouponApplied: boolean = false;
  message: string = '';
  userAddress: any = {};
  paymentUrl: string = '';
  isProcessing: boolean = false;
  // mobileNumber: string = '9999425678';
  redirectUrl: string = 'https://vinmarts.in/payment-status'; // fixed route
  callbackUrl: string = 'https://vinmarts.in'; // backend callback
  productDetails: any;
  productImageUrls = environment.ImageBaseUrl;
  productImageTemp = 'http://localhost:5000/uploads/temp/';
  productDetailss: any;
  newSubtotal: any;
  totalamount: any;
  payments1: any;
  showPaymentOptions: boolean = false;
  onlyOnce: boolean = false;
  paymentMethod: string = 'COD';
  discount: number = 0;
  variantData: any;
  attributeSize: any;
  selectOption: string;
  sessionId: any;
  cashFreeOrderId: any;

  selectedVariant: any;
  selectedSize: any;
  varinatColor: string | null = null;
  variantId: string = 'base';
  readonly PLATFORM_FEE = 5;
  readonly COD_HANDLING_FEE = 30;
  readonly ONLINE_DISCOUNT = 40;
  mrpAmount: number;
  couponDiscount: number;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private api: ApiServiceService,
    private loader: LoaderService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private walletService: WalletServiceService,
  ) {
    // window.addEventListener('message', (event) => {
    //   console.log('ebeneen', event);
    //   if (event.origin === 'https://mercury-t2.phonepe.com') {
    //   // if (event.origin === 'https://mercury-uat.phonepe.com') {
    //     try {
    //       const decodedData = atob(event.data);
    //       const response = JSON.parse(decodedData);
    //       console.log('response', response);
    //       const isSuccess =
    //         response?.bridgeContext?.code === 'CONCLUDED' &&
    //         response?.bridgeContext?.bridgeType ===
    //           'BACK_TO_MERCHANT_CHECKOUT_JS';
    //       const isCancelled =
    //         response?.bridgeContext?.code === 'CANCELLED' &&
    //         response?.bridgeContext?.bridgeType ===
    //           'BACK_TO_MERCHANT_CHECKOUT_JS';
    //       if (isSuccess) {
    //         this.chackOut('prepaid');
    //       } else if (isCancelled) {
    //         window.location.href = 'https://vinmarts.in/payment-fail';
    //       } else {
    //         window.location.href = 'https://vinmarts.in/payment-fail';
    //       }
    //     } catch (error) {
    //       console.error('Error decoding response:', error);
    //       window.location.href = 'https://vinmarts.in/payment-fail';
    //     }
    //   }
    // });
  }

  //   ngOnInit() {
  //     this.route.queryParams.subscribe((params) => {
  //       this.productId = params['product_id'];
  //       this.size = params['size'] || 'small';
  //       this.quantity = +params['quantity'] || 1;

  //       try {
  //         this.variantData = params['variantData']
  //           ? JSON.parse(params['variantData'])
  //           : null;
  //       } catch (err) {
  //         console.error('Error parsing variantData:', err);
  //       }

  //       try {
  //         this.attributeSize = params['sizeData']
  //           ? JSON.parse(params['sizeData'])
  //           : null;
  //       } catch (err) {
  //         console.error('Error parsing variantData:', err);
  //       }
  //  console.log('param----attributeSize', this.attributeSize);

  //       this.getAllUserAddress();
  //       this.getProductByIds();
  //     });

  //   }

  // ngOnInit() {
  //   this.route.queryParams.subscribe((params) => {
  //     this.productId = params['product_id'];
  //     this.quantity = +params['quantity'] || 1;

  //     // ✅ Variant
  //     try {
  //       this.variantData = params['variant']
  //         ? JSON.parse(decodeURIComponent(params['variant']))
  //         : null;
  //       this.selectedSize = params['size']
  //         ? JSON.parse(decodeURIComponent(params['size']))
  //         : null;

  //       this.finalPrice = params['price'];
  //       this.varinatColor = params['variantColor'];
  //       console.log('this.varinatColor --', this.varinatColor);
  //       console.log('variantData-,', this.variantData);
  //     } catch (e) {
  //       console.error('Variant parse error', e);
  //       this.variantData = null;
  //     }

  //     // ✅ Size
  //     try {
  //       this.attributeSize = params['size']
  //         ? JSON.parse(decodeURIComponent(params['size']))
  //         : null;
  //     } catch (e) {
  //       console.error('Size parse error', e);
  //       this.attributeSize = null;
  //     }

  //     this.getAllUserAddress();
  //     this.getProductByIds();
  //   });
  // }
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.productId = params['product_id'];
      this.quantity = +params['quantity'] || 1;
      this.variantId = params['variant_id'] || 'base';

      this.getAllUserAddress();
      this.getProductByIds();
    });
  }

  onSourceButtonClick(event: any): void {
    // console.log('Button clicked in step components', event);
    // this.isSelect = event;
    this.showPaymentOptions = true;
    this.chackOut(event);
    // // console.log('getcartlist' , this.getCartList)
  }

  openPaymentOptions() {
    // 'online' or 'cod'
    this.showPaymentOptions = true; // create Cashfree order with correct amount
  }

  getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        // console.log('Decoded Token:', decodedToken); // Log the decoded token for inspection
        return decodedToken.id || ''; // Ensure this matches the field in your payload
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }

  // increaseQuantity() {
  //   this.quantity++;
  //   this.calculateSummary();
  // }

  // increaseQuantity() {
  //   // Get max stock from product's inventory info
  //   let maxStock = this.productDetailss?.priceInventoryShippingInfo?.stock;

  //   // ✅ Override with attributeSize stock if available
  //   if (this.attributeSize?.stock !== undefined) {
  //     maxStock = this.attributeSize.stock;
  //   }
  //   // Validate if maxStock exists
  //   if (maxStock === undefined || maxStock === null) {
  //     console.warn('Stock information not available');
  //     return;
  //   }

  //   const newQuantity = this.quantity + 1;

  //   if (newQuantity > maxStock) {
  //     // Show warning via toastr or snackbar
  //     this.toastr.warning(
  //       `Only ${maxStock} item(s) available in stock.`,
  //       'Out of Stock',
  //     );
  //     return; // Block increment
  //   }

  //   // Proceed to increase
  //   this.quantity = newQuantity;
  //   this.calculateSummary(); // Recalculate price, etc.
  // }
  increaseQuantity() {
    const maxStock =
      this.selectedVariant?.stock ??
      this.productDetailss?.priceInventoryShippingInfo?.stock;

    if (maxStock === undefined || maxStock === null) {
      console.warn('Stock information not available');
      return;
    }

    const newQuantity = this.quantity + 1;

    if (newQuantity > maxStock) {
      this.toastr.warning(
        `Only ${maxStock} item(s) available in stock.`,
        'Out of Stock',
      );
      return;
    }

    this.quantity = newQuantity;
    this.calculateSummary();
  }

  decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--;
      this.calculateSummary();
    }
  }

  // calculateSummary() {
  //   if (!this.productDetailss) return;

  //   let price = 0;

  //   // 1️⃣ Size price (highest priority)
  //   if (this.attributeSize?.price) {
  //     price = this.attributeSize.price;
  //   }
  //   // 2️⃣ Variant price
  //   else if (this.variantData?.sellingPrice) {
  //     price = this.variantData.sellingPrice;
  //   }
  //   // 3️⃣ Product base price
  //   else {
  //     price =
  //       this.productDetailss?.priceInventoryShippingInfo?.sellingPrice || 0;
  //   }

  //   this.subTotal = price * this.quantity;
  //   this.shippingCharge =
  //     this.productDetailss?.priceInventoryShippingInfo?.sippingCharge || 0;

  //   this.total = this.subTotal;
  // }

  // get displayPrice(): number {
  //   // 3️⃣ Variant + size selected → size price
  //   if (this.attributeSize?.price) {
  //     return this.attributeSize.price;
  //   }

  //   // 2️⃣ Variant selected but no size → variant price
  //   if (this.variantData?.sellingPrice) {
  //     return this.variantData.sellingPrice;
  //   }

  //   // 1️⃣ No variant → default product price
  //   return this.productDetailss?.priceInventoryShippingInfo?.sellingPrice || 0;
  // }

  // getProductByIds() {
  //   const userId = this.getCurrentUserId();
  //   if (this.productId) {
  //     this.api
  //       .getProductById(this.productId, userId)
  //       .subscribe((product: any) => {
  //         this.productDetailss = product.data;
  //         console.log('productDetailss-->', this.productDetailss);
  //         this.calculateSummary();
  //       });
  //   }
  // }
  getProductByIds() {
    const userId = this.getCurrentUserId();
    if (this.productId) {
      this.api
        .getProductById(this.productId, userId)
        .subscribe((product: any) => {
          this.productDetailss = product.data;
          this.resolveSelectedVariant();
          this.calculateSummary();
        });
    }
  }

  // NEW: mirrors product-details.component's buildVariantOptions() logic —
  // resolves the exact selected option (base product OR a specific variant
  // sub-document) instead of trusting query-string JSON.
  private resolveSelectedVariant() {
    if (this.variantId && this.variantId !== 'base') {
      const match = (this.productDetailss?.variants || []).find(
        (v: any) => v._id === this.variantId,
      );
      if (match) {
        this.selectedVariant = match;
        const colorType = match.variantTypes?.find(
          (vt: any) => vt.key?.toLowerCase() === 'color',
        );
        const sizeType = match.variantTypes?.find(
          (vt: any) => vt.key?.toLowerCase() === 'size',
        );
        this.varinatColor = colorType?.values?.[0] || null;
        this.selectedSize = sizeType?.values?.[0] || null;
        return;
      }
    }

    // Base product
    this.selectedVariant = null;
    const baseColorType = this.productDetailss?.variantTypes?.find(
      (vt: any) => vt.key?.toLowerCase() === 'color',
    );
    const baseSizeType = this.productDetailss?.variantTypes?.find(
      (vt: any) => vt.key?.toLowerCase() === 'size',
    );
    this.varinatColor =
      baseColorType?.values?.[0] || this.productDetailss?.productColor || null;
    this.selectedSize = baseSizeType?.values?.[0] || null;
  }

  applyCoupon() {
    const userId = this.getCurrentUserId();
    // Prepare the payload with the coupon code and user ID
    // const para = {
    //   code: this.couponCode,
    //   userId: userId,
    //   productId: this.productId,
    //   variantData: this.variantData,
    //   attributeSize: this.attributeSize,
    // };

    const para = {
      code: this.couponCode,
      userId: userId,
      productId: this.productId,
      variantId: this.variantId,
    };

    // ✅ Add size attributes if user selected a size

    // Call API to apply the coupon
    this.api.applyCoupon(para).subscribe({
      next: (response: any) => {
        const coupondata = response;
        // console.log('response coupon code' ,coupondata)
        // Assuming the API response contains 'discount' and 'newTotal'
        if (
          response &&
          response.discount !== undefined &&
          response.newPrice !== undefined
        ) {
          this.discountPrice = response.discount; // Discount amount
          if (this.attributeSize) {
            this.newSubtotal = this.attributeSize.price; // Subtotal after applying the coupon
            console.log('this,nettoal', this.newSubtotal);
          } else {
            this.newSubtotal = response.newPrice; // Subtotal after applying the coupon

            console.log('this,nettoal norml', this.newSubtotal);
          }
          // Set success message and status
          this.isCouponApplied = true;
          this.message = `Coupon applied successfully! You saved ₹${this.discountPrice.toFixed(
            2,
          )}.`;
          this.calculateSummary(); // Ensure recalculation after applying coupon
        } else {
          // Handle unexpected response
          this.couponCode = '';
          this.discountPrice = 0;
          this.isCouponApplied = false;

          this.message =
            'Invalid coupon or could not apply the coupon. Please try again.';
        }
        this.total = this.getFinalAmount(); // ✔ recompute
      },
      error: (err: any) => {
        this.couponCode = '';
        this.discountPrice = 0;
        this.isCouponApplied = false;

        this.message =
          'Failed to apply coupon: ' +
          (err.error?.message || 'Invalid coupon code');
      },
    });
  }

  getAllUserAddress() {
    this.api.getAllUserAddress().subscribe(
      (addressData: any) => {
        this.userAddress = addressData.data;
      },
      (error) => {
        this.toastr.error('Failed to fetch address details.');
      },
    );
  }

  selectPaymentOption(method: string) {
    this.selectOption = method;
    console.log('mmmm', method);
    // ONLINE → create Cashfree order
    if (method === 'cc,dc' || method === 'upi') {
      this.initiatePayment(method);
    }

    // COD → do NOT create Cashfree order
    if (method === 'cod') {
      this.sessionId = null;
      this.cashFreeOrderId = null;
    }

    // Recalculate amount
    // this.total = this.getFinalAmount();
  }

  // initiatePayment() {
  //   const selectedAddress = this.userAddress.find(
  //     (address: any) => address.isDefault === true
  //   );
  //   const payload = {
  //     amount: (this.total - this.discountPrice) * 100 - 40 * 100,
  //     redirectUrl: this.redirectUrl,
  //     callbackUrl: this.callbackUrl,
  //     mobileNumber: selectedAddress?.delivery_mobile,
  //   };

  //   this.api.initiatePayment(payload).subscribe(
  //     (response) => {
  //       if (response.paymentUrl) {
  //         this.paymentUrl = response.paymentUrl;
  //         this.payments1 = this.sanitizer.bypassSecurityTrustResourceUrl(
  //           response.paymentUrl
  //         );
  //         this.loader.hideLoader();
  //         this.showPaymentOptions = true; // Ensure this is set after payments1 is updated
  //       } else {
  //         alert('Payment initiation failed!');
  //         this.loader.hideLoader();
  //       }
  //     },
  //     (error) => {
  //       console.error('Error:', error);
  //       alert('Payment initiation error!');
  //       this.loader.hideLoader();
  //     }
  //   );
  // }

  // getFinalAmount(): number {
  //   let amount = this.subTotal;

  //   if (this.discountPrice) {
  //     amount -= this.discountPrice;
  //   }

  //   if (this.selectOption === 'online') {
  //     amount -= 40; // online discount
  //   }

  //   return Math.max(amount, 0);
  // }
  getFinalAmount(): number {
    let amount = this.mrpTotal; // start from MRP, like the summary panel
    amount -= Math.max(this.mrpTotal - this.subTotal, 0); // MRP discount
    if (this.discountPrice) amount -= this.discountPrice; // coupon

    amount += this.PLATFORM_FEE;

    if (this.selectOption === 'cod') {
      amount += this.COD_HANDLING_FEE;
    }

    return Math.max(amount, 0);
  }

  // getFinalAmount() {
  //   let amount = this.total;

  //   // online discount
  //   if (this.selectOption === 'online') {
  //     amount -= 40;
  //   }

  //   return amount;
  // }

  // getDisplayImage(): string {
  //   if (this.variantData?.images?.length) {
  //     return this.productImageTemp + this.variantData.images?.[0];
  //   }
  //   return this.productImageUrls + this.productDetailss?.images?.[0];
  // }
  calculateSummary() {
    if (!this.productDetailss) return;

    const price =
      this.selectedVariant?.sellingPrice ??
      this.productDetailss?.priceInventoryShippingInfo?.sellingPrice ??
      0;

    this.subTotal = price * this.quantity;
    this.shippingCharge =
      this.productDetailss?.priceInventoryShippingInfo?.sippingCharge || 0;
    this.total = this.subTotal;
  }

  get displayPrice(): number {
    return (
      this.selectedVariant?.sellingPrice ??
      this.productDetailss?.priceInventoryShippingInfo?.sellingPrice ??
      0
    );
  }

  get displayMRP(): number {
    return (
      this.selectedVariant?.MRP ??
      this.productDetailss?.priceInventoryShippingInfo?.MRP ??
      0
    );
  }
  get mrpTotal(): number {
    return this.displayMRP * this.quantity;
  }

  get mrpDiscount(): number {
    return Math.max((this.mrpAmount || 0) - (this.totalamount || 0), 0);
  }

  get totalDiscounts(): number {
    return (this.mrpDiscount || 0) + (this.couponDiscount || 0);
  }

  get onlineTotal(): number {
    return Math.max(
      (this.mrpAmount || 0) + this.PLATFORM_FEE - this.totalDiscounts,
      0,
    );
  }

  get codTotal(): number {
    return Math.max(
      (this.mrpAmount || 0) +
        this.PLATFORM_FEE +
        this.COD_HANDLING_FEE -
        this.totalDiscounts,
      0,
    );
  }

  getDisplayImage(): string {
    // FIX: variant images were previously read from a different "temp" host
    // than base images, causing broken/mismatched URLs. Variant images are
    // saved the same way as base images, so use the same base URL for both.
    const images = this.selectedVariant?.images?.length
      ? this.selectedVariant.images
      : this.productDetailss?.images;
    return this.productImageUrls + (images?.[0] || '');
  }
  initiatePayment(paymentMethod: any) {
    const finalAmount = this.getFinalAmount(); // ✅ always correct

    const selectedAddress = this.userAddress.find(
      (address: any) => address.isDefault === true,
    );

    // const amount = item.settlement?.netAmount || 0;

    const payload = {
      orderId: 'order_' + Date.now(),
      amount: finalAmount,
      customerName: selectedAddress.user_id?.name,
      customerEmail: selectedAddress.user_id?.email,
      customerPhone: selectedAddress?.user_id?.mobile,
      paymentMethod,
      // netAmmount
    };

    this.api.createCashFreeOrder(payload).subscribe(
      (res: any) => {
        if (res.success) {
          this.sessionId = res.payment_session_id;
          this.cashFreeOrderId = res.order_id;
        } else {
          this.toastr.error('Payment creation failed!');
        }
      },
      (err) => {
        console.error(err);
        this.toastr.error('Payment error!');
      },
    );
  }

  onCodSelected() {
    console.log('📦 COD selected — placing order without ₹40 deduction');
    this.chackOut('COD'); // ✅ backend should use full amount (subTotal - coupon only)
  }

  onPaymentSuccess(details: any) {
    console.log('Payment Success:', details);

    // Now call checkout API
    this.chackOut('Prepaid');
  }

  chackOut(paymentMethod: any) {
    if (this.isProcessing) return;
    this.isProcessing = true;

    return new Promise((resolve, reject) => {
      this.loader.showLoader();

      const selectedAddress = this.userAddress.find(
        (address: any) => address.isDefault === true,
      );

      const addressId = selectedAddress ? selectedAddress._id : null;
      const validCoupon = this.isCouponApplied && this.couponCode?.trim();

      const para = {
        address_id: addressId,
        payment_gateway: paymentMethod,
        accept: true,
        shipping_charge:
          Number(
            this.productDetailss?.priceInventoryShippingInfo?.sippingCharge,
          ) || 0,
        // coupon_amount: Number(this.discountPrice) || 0,
        // coupon_code: this.couponCode || '',
        coupon_amount: validCoupon ? Number(this.discountPrice) || 0 : 0,

        coupon_code: validCoupon ? this.couponCode.trim() : '',
        direct_purchase: true,
        product_id: this.productDetailss?._id || '',
        quantity: Number(this.quantity) || 1,
        variant_id: this.variantId,
        color: this.varinatColor,
        size: this.selectedSize,
      };

      if (paymentMethod === 'COD') {
        this.onlyOnce = true;
        this.cancelOnlinePayment();
      }

      this.api.chackOut(para).subscribe({
        next: (res: any) => {
          if (res) {
            const userId = this.getCurrentUserId();
            // Cashback API Payload
            const rewardParam = {
              user_Id: userId,
              order_Id: res.data._id,
              reward: Number(this.discountPrice),
              coupon_code: this.couponCode.trim(),
              type: 'Credit',
              description: `Cashback on Order #${res.data._id}`,
            };

            // Cashback API Call
            this.api.updateReward(rewardParam).subscribe({
              next: (rewardRes: any) => {
                console.log('Reward Added', rewardRes);
                const newBalance = Number(rewardRes?.history?.balance) || 0;

                // Checkout component ka balance
                this.balance = newBalance;

                // 🔥 Header ko immediately updated balance bhejo
                this.walletService.updateBalance(newBalance);
                this.loader.hideLoader();

                this.router.navigate(['order-sumamary'], {
                  queryParams: {
                    id: res.data._id,
                  },
                });

                this.isProcessing = false;
                resolve(true);
              },

              error: (err: any) => {
                console.log('Reward API Error', err);

                // Checkout ho chuka hai isliye reward fail hone par bhi redirect
                this.loader.hideLoader();

                this.router.navigate(['order-sumamary'], {
                  queryParams: {
                    id: res.data._id,
                  },
                });

                this.isProcessing = false;
                resolve(true);
              },
            });
          }
        },

        error: (err) => {
          console.error(err);

          this.loader.hideLoader();

          this.toastr.error(err?.error?.message || 'Checkout failed.');

          this.isProcessing = false;

          reject(err);
        },
      });
    });
  }
  cancelOnlinePayment() {
    // Fire a custom postMessage event to simulate a cancel action
    const iframe = document.getElementById('paymentFrame') as HTMLIFrameElement;

    if (iframe) {
      const cancelMessage = {
        action: 'cancel', // Define your cancel action
        reason: 'User selected COD', // Optional: Add a reason
      };

      // Send a cancel message to the iframe
      iframe.contentWindow?.postMessage(
        JSON.stringify(cancelMessage),
        'https://mercury-uat.phonepe.com',
      );
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(MyModalComponent, {
      width: '50%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getAllUserAddress();
    });
  }
}
